import { defineStore, storeToRefs } from "pinia";
import { ref } from "vue";
import useUserStore from "@/stores/user";

export default defineStore("site_notifications", () => {
  const userStore = useUserStore();
  const { vendorKey } = storeToRefs(userStore);

  const site_notifications = ref([]);
  const notificationsLoaded = ref(false);

  async function getSiteNotifications() {
    if (notificationsLoaded.value === false) {
      try {
        const response = await fetch(
          `/api/cmp/${vendorKey.value}/site_notifications/`,
        );

        if (!response.ok) {
          throw new Error("Failed to get site notifications");
        }

        site_notifications.value = await response.json();
      } finally {
        notificationsLoaded.value = true;
      }
    }
    return;
  }
  function removeNotification(id) {
    site_notifications.value = site_notifications.value.filter(
      (n) => n.id !== id,
    );
  }
  return {
    site_notifications,
    getSiteNotifications,
    removeNotification,
    notificationsLoaded,
  };
});
